<template>
    <div class="check_list" @click="onDetail(invoice.id)">
        <div class="check_list_top">
            <span v-text="invoice.invoiceNo"></span>
            <span>{{ filterStatus(invoice.status) }}</span>
        </div>
        <div class="check_list_center">
            <CheckList v-for="(item, index) in inputList" :item='item' :key='index' />
        </div>
        <div class="check_list_foot" v-if="!invoice.status && invoice.rejectReason">拒审原因：{{ invoice.rejectReason }}</div>
    </div>
</template>

<script>
import moment from 'moment'
import CheckList from '../common/checkList'
export default {
    props: {
        invoice: {
            type: Object,
            default: () => {
                return {}
            }
        },
        active: {
            type: Number,
            default: 1
        }
    },
    components: {
        CheckList
    },
    data () {
        return {
            inputList: []
        }
    },
    methods: {
        filterStatus (value) {
            switch (value) {
                case 10:
                    return '审核中'
                case 20:
                    return '审核中'
                case 30:
                    return '已开票'
                case 0:
                    return '已拒审'
                default:
                    return '待开票'
            }
        },
        NumFormat (val) {
            if (val === '' || val == null) {
                return val
            }
            let value = Number(val).toFixed(2)
            let s = value.toString().indexOf('.')
            if (s === -1) {
                return (value || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
            } else {
                let arr = value.toString().split('.')
                return (arr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + arr[1]
            }
        },
        initData () {
            let data = this.invoice
            this.inputList = [
                { label: '收款方', content: data.authenticationMerchantName },
                { label: '开票金额', content: `¥${this.NumFormat(data.totalAmount)}`, colTrue: true },
                { label: '开票时间', content: moment(data.createTime).format('YYYY-MM-DD') },
                { label: '付款方', content: data.authenticationMemberName }
            ]
            if (this.active === 2) {
                this.inputList = [
                    ...this.inputList,
                    { label: '发票代码', content: data.invoiceCode },
                    { label: '发票号码', content: data.invoiceNumber },
                    { label: '快递单号', content: data.deliveryCompanyName + ' ' + data.deliveryNo }
                ]
            }
        },
        onDetail (id) {
            this.$router.push({ path: '/b2b/invoice/invoiceDetail', query: { id: id, active: this.active } })
        }
    },
    mounted () {
        this.initData()
    }
}
</script>

<style lang="scss" scoped>
.check {
    &_list {
        margin-bottom: 20px;
        background-color: #fff;
        border-radius: 8px;
        &_top {
            display: flex;
            justify-content: space-between;
            height: 64px;
            line-height: 64px;
            font-size: 26px;
            border-bottom: 2px solid #EDEDF0;
            padding: 0 24px;
            color: #333;
            span:last-child {
                color: #FF7A45;
            }
        }
        &_center {
            padding: 24px;
            font-size: 28px;
            p {
                display: flex;
                justify-content: start;
                font-size: 24px;
                span {
                    font-size: 28px;
                    color: #000;
                    &:first-child {
                        color: #666;
                        width: 112px;
                        text-align: left;
                        margin-right: 32px;
                    }
                    &.colFF7A45 {
                        color: #FF7A45;
                    }
                }
                &:not(:last-child) {
                    margin-bottom: 24px;
                }
            }
        }
        &_foot {
            border-top: 2px solid #EDEDF0;
            padding: 24px;
            color: #FF7A45;
        }
    }
}
</style>